import React, { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Clipboard2Check,
  CreditCard2Back,
  Headset,
  Heart,
  Person,
  Star,
} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
type Props = {
  setShow?: React.Dispatch<React.SetStateAction<boolean>>;
};

const MenuList: FC<Props> = ({ setShow }) => {
  const lng = useGetUrlLocale();
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <ul className="nav flex-column">
      <li className="nav-item mb-1">
        <Link
          to={`${lng}/profile`}
          className={`nav-link ${location.pathname.includes("/profile") ? "active" : ""}`}
          onClick={() => setShow?.(false)}
        >
          <Person className="me-2 fs-6" />
          {t("menu.profile")}
        </Link>
      </li>
      <li className="nav-item mb-1">
        <Link
          to={`${lng}/my-reservations`}
          className={`nav-link ${location.pathname.includes("/my-reservations") ? "active" : ""}`}
          onClick={() => setShow?.(false)}
        >
          <Clipboard2Check className="me-2 fs-6" />
          {t("menu.reservations")}
        </Link>
      </li>
      <li className="nav-item mb-1">
        <Link
          to={`${lng}/my-reviews`}
          className={`nav-link ${location.pathname.includes("/my-reviews") ? "active" : ""}`}
          onClick={() => setShow?.(false)}
        >
          <Star className="me-2 fs-6" />
          {t("menu.reviews")}
        </Link>
      </li>
      <li className="nav-item mb-1">
        <Link
          to={`${lng}/favorites`}
          className={`nav-link ${location.pathname.includes("/favorites") ? "active" : ""}`}
          onClick={() => setShow?.(false)}
        >
          <Heart className="me-2 fs-6" />
          {t("menu.favorites")}
        </Link>
      </li>
      <li className="nav-item mb-1">
        <Link
          to={`${lng}/payment`}
          className={`nav-link ${location.pathname.includes("/payment") ? "active" : ""}`}
          onClick={() => setShow?.(false)}
        >
          <CreditCard2Back className="me-2 fs-6" />
          {t("menu.payment")}
        </Link>
      </li>
      <li className="nav-item mb-1">
        <Link
          to={`${lng}/support`}
          className={`nav-link ${location.pathname.includes("/support") ? "active" : ""}`}
          onClick={() => setShow?.(false)}
        >
          <Headset className="me-2 fs-6" />
          {t("menu.support")}
        </Link>
      </li>
    </ul>
  );
};
export default MenuList;
